import { Injectable, inject } from '@angular/core';
import { NgKLoggerService } from '@kin/ngk-logger';
import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';

import { WA_LOCAL_STORAGE_DRAFT_TOKEN_KEY } from 'app/home/create-quote/services/entry/quote-draft-entry.service';
import { QuoteDraftStore } from 'app/home/global-store/quote-draft';
import { QuoteFormOptionsStore } from 'app/home/global-store/quote-form-options';
import { UserStore } from 'app/home/global-store/user/user.store';

/**
 * Global Store Service
 * - used to perform actions on multiple stores through a single point.
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalStoreActionsService {
  private quoteDraftStore = inject(QuoteDraftStore);
  private optionsStore = inject(QuoteFormOptionsStore);
  private userStore = inject(UserStore);
  private localStorage = inject(WA_LOCAL_STORAGE);
  private logger = inject(NgKLoggerService);

  public resetQuote() {
    this.quoteDraftStore.reset();
    this.optionsStore.reset();
    this.userStore.endQuoting();
    this.localStorage?.removeItem(WA_LOCAL_STORAGE_DRAFT_TOKEN_KEY);
  }

  public newQuote() {
    this.quoteDraftStore.reset();
    this.optionsStore.reset();
    this.userStore.endQuoting();
  }

  public ejectUser(reason: string) {
    this.resetQuote();
    this.logger.event({ metaData: { reason }, name: 'user-ejected' });
  }
}
